import { AppDateTimeInfo } from '@components/AppComponents'
import { ApiService } from '@services/ApiService'
import appStore from '@stores/appStore'
import { Spin } from 'antd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import React from 'react'

import AppModal from '../AppModal'

import RecentChangeForm from './RecentChangeForm'

const renderValue = value => {
  if (!value || value === 'null') {
    return ''
  }
  const isHtmlContent = appStore.isHTML(value)
  value = value.replaceAll('"', '')
  return (
    <div>
      {isHtmlContent ? (
        <div
          style={{
            maxWidth: '400px',
            wordBreak: 'break-word',
            whiteSpace: 'normal',
            overflowWrap: 'break-word',
          }}
          dangerouslySetInnerHTML={{ __html: value }}
        />
      ) : (
        <div
          style={{
            maxWidth: '400px',
            wordBreak: 'break-word',
            whiteSpace: 'normal',
            overflowWrap: 'break-word',
          }}
        >
          <p>{value.replaceAll('"', '').replaceAll(/\\n/g, '\n')}</p>
        </div>
      )}
    </div>
  )
}

export const columnsWithReferenceTable = [
  {
    title: 'Old Value',
    accessor: 'originalValueExtraInfo',
    Cell: (_, record) => record.originalValueExtraInfo?.text,
  },
  {
    title: 'New Value',
    accessor: 'newValueExtraInfo',
    Cell: (_, record) => record.newValueExtraInfo?.text,
  },
  {
    title: 'Updated By',
    accessor: 'user',
    Cell: (_, record) => record.user?.displayName,
  },

  {
    title: 'Updated At',
    Cell: (_, record) => <AppDateTimeInfo date={record.executionTime} />,
  },
]

export const defaultColumns = [
  {
    title: 'Old Value',
    accessor: 'originalValue',
    Cell: (_, record) => renderValue(record.originalValue),
  },
  {
    title: 'New Value',
    accessor: 'newValue',
    Cell: (_, record) => renderValue(record.newValue),
  },
  {
    title: 'Updated By',
    accessor: 'user',
    Cell: (_, record) => record.user?.displayName,
  },

  {
    title: 'Updated At',
    accessor: 'changeTime',
    Cell: (_, record) => <AppDateTimeInfo date={record.changeTime} />,
  },
]

interface Props {
  entityId: string
  propertyReferenceTable?: string
  propertyName: string
  optionsValue?: any[]
  title?: string
  columns: Array<any>
  open: boolean
  onCancel?: () => void
  modalWidth?: number
}

class ModalRecentChange extends React.Component<Props, any> {
  state = {
    loading: false,
    data: { items: [], totalCount: 0 },
  }
  componentDidMount() {
    this.getRecentChange()
  }

  async getRecentChange() {
    try {
      this.setState({ loading: true })
      const { entityId, propertyName, propertyReferenceTable, optionsValue } =
        this.props
      if (!entityId) {
        return
      }

      const { data } = await ApiService.EntityHistory.getRecentChangeById(
        entityId,
        {
          propertyName,
          propertyReferenceTable,
          maxResultCount: 100,
        }
      )

      if (data.items.length > 0) {
        data.items.forEach(item => {
          if (propertyName === 'auditConsent') {
            const mapValue = val => {
              const cleaned = val?.replace?.(/"/g, '')
              if (cleaned === 'true') {
                return 'Completed'
              }
              if (cleaned === 'false') {
                return 'Not Completed'
              }
              return cleaned
            }
            item.originalValue = mapValue(item.originalValue)
            item.newValue = mapValue(item.newValue)
          } else if (optionsValue) {
            const mapFromOptions = val => {
              const cleaned = val?.replace?.(/"/g, '')
              return (
                optionsValue.find(x =>
                  typeof x.id === 'number'
                    ? x.id === Number(cleaned)
                    : x.id === cleaned
                )?.displayName ?? val
              )
            }

            item.originalValue = mapFromOptions(item.originalValue)
            item.newValue = mapFromOptions(item.newValue)
          }
        })

        this.setState({ data })
      }
    } catch (error) {
      console.error(error)
    } finally {
      this.setState({ loading: false })
    }
  }

  render() {
    const {
      open,
      columns,
      onCancel,
      title = 'View changes',
      modalWidth,
    } = this.props
    const { data, loading } = this.state

    return (
      <AppModal
        open={open}
        width={modalWidth ?? 900}
        title={title}
        onCancel={onCancel}
      >
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Spin />
          </div>
        ) : (
          <RecentChangeForm
            dataRecentChange={data.items}
            columns={toJS(columns)}
          />
        )}
      </AppModal>
    )
  }
}

export default observer(ModalRecentChange)
